'use client';

import Icon from '@/components/ui/AppIcon';

const BlogHero = () => {
  return (
    <section className="relative min-h-[60vh] overflow-hidden bg-black pt-20">
      <div className="absolute inset-0 top-20">
        <img
          src="https://images.unsplash.com/photo-1620477067547-f103911f37b0"
          alt="Hayat Interiors Design Studio - Modern Indian interior design"
          className="w-full h-full object-cover scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/60 via-black/40 to-transparent" />
        <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent" />
      </div>

      <div className="relative min-h-[60vh] flex items-center py-12 md:py-16 lg:py-32">
        <div className="w-full px-4 md:px-8 lg:px-20 max-w-[1400px] mx-auto">
          <div className="max-w-4xl space-y-4 md:space-y-6">
            <div className="inline-flex items-center gap-2.5 px-5 py-2.5 rounded-full bg-white/10 backdrop-blur-xl border border-white/20">
              <Icon name="BookOpenIcon" size={16} className="text-white" />
              <span className="text-xs font-medium text-white/90 tracking-widest uppercase">
                Knowledge Hub
              </span>
            </div>

            <h1 className="font-headline text-3xl sm:text-4xl md:text-5xl lg:text-7xl font-normal leading-tight md:leading-[0.95] text-white tracking-tight">
              Stories & Insights
              <span className="block font-normal mt-2">From Our Studio</span>
            </h1>

            <p className="text-base md:text-lg lg:text-xl text-white/80 leading-relaxed max-w-2xl font-normal">
              Real projects, honest advice, and authentic perspectives on creating homes that blend modern minimalism with Indian heritage.
            </p>

            <div className="flex flex-wrap gap-6 pt-4">
              <div className="flex items-center gap-2 text-white/70">
                <Icon name="DocumentTextIcon" size={18} />
                <span className="text-sm font-normal">100+ Projects</span>
              </div>
              <div className="flex items-center gap-2 text-white/70">
                <Icon name="UserGroupIcon" size={18} />
                <span className="text-sm font-normal">Year 2025</span>
              </div>
              <div className="flex items-center gap-2 text-white/70">
                <Icon name="SparklesIcon" size={18} />
                <span className="text-sm font-normal">Authentic Insights</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BlogHero;